export default class AddressPage {
  constructor(theme, element) {
    this.element = element;
    this.addressTables = this.element.querySelectorAll('.address_table');

    Array.prototype.forEach.call(
      this.addressTables,
      (address) => {
        address.addEventListener('click', (e) => {
          if ( e.target.classList.contains('action_edit') ) {
            e.target.setAttribute("aria-expanded", "true");
          }

          if ( e.target.classList.contains('action_cancel') ) {
            address.querySelector('.action_edit').setAttribute("aria-expanded", "false");
          }
        });
      }
    );
  }
}
